/** Canonical navigation uses deployment configuration, never a query URL. */
export function canonicalPortalLocation(
  current: URL,
  portalUrl: string,
): string | null {
  if (!portalUrl) return null;
  let portal: URL;
  try {
    portal = new URL(portalUrl);
  } catch {
    return null;
  }
  if (!['http:', 'https:'].includes(portal.protocol)) return null;
  const isPortalPath = /^\/portal(?:\/|$)/.test(current.pathname);
  if (current.origin !== portal.origin && isPortalPath) {
    return `${portal.origin}${current.pathname}${current.search}${current.hash}`;
  }
  if (current.origin !== portal.origin) return null;
  if (current.pathname === '/login')
    return `${portal.origin}/portal/login${current.search}`;
  if (current.pathname === '/')
    return `${portal.origin}/portal${current.search}`;
  if (
    isPortalPath ||
    [
      '/auth/action',
      '/forgot-password',
      '/auth/microsoft/signin-callback',
    ].includes(current.pathname)
  )
    return null;
  // The client host never renders an advisor page, even from a saved bookmark.
  return `${portal.origin}/portal`;
}
